import { render, staticRenderFns } from "./PFDistributionFront.vue?vue&type=template&id=3ed71050"
import script from "./PFDistributionFront.vue?vue&type=script&lang=js"
export * from "./PFDistributionFront.vue?vue&type=script&lang=js"
import style0 from "./PFDistributionFront.vue?vue&type=style&index=0&id=3ed71050&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports